import React from 'react';
import { Layers, CheckCircle, Loader } from 'lucide-react';

/**
 * Batch File Upload Component
 */
export const BatchUploader = ({
  batchFiles,
  onBatchFileSelect,
  onBatchUpload,
  onClear,
  batchProcessing
}) => {
  const handleFilesChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    const validFiles = selectedFiles.filter(f => f.name.toLowerCase().endsWith('.stl'));
    
    if (validFiles.length > 0 && validFiles.length <= 20) {
      onBatchFileSelect(validFiles);
    }
  };

  return (
    <div className="bg-bg-light p-8 rounded-lg border border-text-muted/20 mb-6" data-testid="batch-uploader">
      <div className="text-center">
        {batchFiles.length === 0 ? (
          <label className="cursor-pointer block">
            <input
              type="file"
              accept=".stl"
              multiple
              onChange={handleFilesChange}
              className="hidden"
              data-testid="batch-file-input"
            />
            <div className="border-2 border-dashed border-text-muted/30 rounded-lg p-12 hover:border-accent/50 transition-colors">
              <Layers className="w-16 h-16 text-text-muted mx-auto mb-4" />
              <p className="text-white font-semibold mb-2">
                Click to upload multiple STL files
              </p>
              <p className="text-text-secondary text-sm">
                Maximum 20 files per batch
              </p>
            </div>
          </label>
        ) : (
          <div className="space-y-4">
            <div className="text-left max-h-48 overflow-y-auto">
              {batchFiles.map((f, i) => (
                <div key={i} className="flex items-center gap-3 text-white py-2 border-b border-text-muted/10">
                  <CheckCircle className="w-4 h-4 text-green-400" />
                  <span className="font-medium">{f.name}</span>
                  <span className="text-text-secondary text-sm">
                    ({(f.size / 1024 / 1024).toFixed(2)} MB)
                  </span>
                </div>
              ))}
            </div>
            <p className="text-text-secondary text-sm">
              {batchFiles.length} file(s) selected
            </p>
            <div className="flex gap-3 justify-center">
              <button
                onClick={onClear}
                className="px-4 py-2 bg-bg-dark text-text-secondary hover:text-white rounded-lg transition-colors"
                data-testid="batch-clear-btn"
              >
                Clear
              </button>
              <button
                onClick={onBatchUpload}
                disabled={batchProcessing}
                className="px-6 py-3 bg-accent hover:bg-accent-hover text-white rounded-lg font-semibold disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                data-testid="batch-process-btn"
              >
                {batchProcessing ? (
                  <span className="flex items-center gap-2">
                    <Loader className="w-5 h-5 animate-spin" />
                    Processing Batch...
                  </span>
                ) : (
                  `Process ${batchFiles.length} Files`
                )}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default BatchUploader;
